export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59')
];

export const server_loads = [];

export const dictionary = {
		"/": [15],
		"/account": [20],
		"/account/verify-email": [21],
		"/admin": [22,[3]],
		"/admin/blacklist-hits": [39,[3,7]],
		"/admin/invites": [40,[3]],
		"/admin/settings": [41,[3]],
		"/admin/speakers": [42,[3,8]],
		"/admin/speakers/new": [45,[3,8]],
		"/admin/speakers/[speaker_tag]": [43,[3,8,9]],
		"/admin/speakers/[speaker_tag]/edit": [44,[3,8,9]],
		"/admin/stats": [46,[3,10]],
		"/admin/stats/[stream_tag]": [47,[3,10]],
		"/admin/streams": [48,[3,11]],
		"/admin/streams/new": [52,[3,11]],
		"/admin/streams/[stream_tag]": [49,[3,11,12]],
		"/admin/streams/[stream_tag]/edit": [50,[3,11,12]],
		"/admin/streams/[stream_tag]/refresh": [51,[3,11,12]],
		"/admin/[tag]": [23,[3,4]],
		"/admin/[tag]/moderation": [24,[3,4]],
		"/admin/[tag]/overlay": [25,[5]],
		"/admin/[tag]/panel": [26,[3,4]],
		"/admin/[tag]/settings": [27,[3,4,6]],
		"/admin/[tag]/settings/goals": [28,[3,4,6]],
		"/admin/[tag]/settings/image-tips": [29,[3,4,6]],
		"/admin/[tag]/settings/overlay": [30,[3,4,6]],
		"/admin/[tag]/settings/overlay/[short_id]": [31,[3,4,6]],
		"/admin/[tag]/settings/payments": [32,[3,4,6]],
		"/admin/[tag]/settings/show": [33,[3,4,6]],
		"/admin/[tag]/settings/text-tips": [34,[3,4,6]],
		"/admin/[tag]/settings/voice-tips": [35,[3,4,6]],
		"/admin/[tag]/verify-email": [36,[3,4]],
		"/admin/[tag]/voices/new": [38,[3,4]],
		"/admin/[tag]/voices/[voice_tag]": [37,[3,4]],
		"/leaderboard": [53],
		"/onboard": [55,[14]],
		"/o/[short_id]": [54,[13]],
		"/privacy": [56],
		"/signin": [57],
		"/submission": [58],
		"/terms": [59],
		"/[tag]": [16,[2]],
		"/[tag]/image": [17,[2]],
		"/[tag]/text": [18,[2]],
		"/[tag]/voice": [19,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';